// components/PasswordRequirements.js
import React from 'react'

/**
 * Reusable component to display password requirements with visual feedback
 * @param {Object} passwordStrength - Object with boolean flags for each requirement
 * @param {boolean} passwordStrength.hasMinLength - Whether password has minimum 8 characters
 * @param {boolean} passwordStrength.hasUpperCase - Whether password has uppercase letter
 * @param {boolean} passwordStrength.hasLowerCase - Whether password has lowercase letter
 * @param {boolean} passwordStrength.hasNumber - Whether password has number
 * @param {boolean} passwordStrength.hasSpecialChar - Whether password has special character
 */
function PasswordRequirements ({ passwordStrength }) {
  if (!passwordStrength) {
    return null
  }

  return (
    <div style={{ marginTop: '8px', fontSize: '0.85rem' }}>
      <div style={{ marginBottom: '6px', fontWeight: '500', color: '#666' }}>
        Passwort-Anforderungen:
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <div style={{ color: passwordStrength.hasMinLength ? '#4caf50' : '#f44336' }}>
          {passwordStrength.hasMinLength ? '✓' : '✗'} Mindestens 8 Zeichen
        </div>
        <div style={{ color: passwordStrength.hasUpperCase ? '#4caf50' : '#f44336' }}>
          {passwordStrength.hasUpperCase ? '✓' : '✗'} Mindestens ein Großbuchstabe
        </div>
        <div style={{ color: passwordStrength.hasLowerCase ? '#4caf50' : '#f44336' }}>
          {passwordStrength.hasLowerCase ? '✓' : '✗'} Mindestens ein Kleinbuchstabe
        </div>
        <div style={{ color: passwordStrength.hasNumber ? '#4caf50' : '#f44336' }}>
          {passwordStrength.hasNumber ? '✓' : '✗'} Mindestens eine Zahl
        </div>
        <div style={{ color: passwordStrength.hasSpecialChar ? '#4caf50' : '#f44336' }}>
          {passwordStrength.hasSpecialChar ? '✓' : '✗'} Mindestens ein Sonderzeichen (!@#$% etc.)
        </div>
      </div>
    </div>
  )
}

export default PasswordRequirements



